import React, { createContext, useContext } from "react";

const MainContext = createContext();

export const MainThemeProvider = ({ children }) => {
  return <MainContext.Provider value={{}}>{children}</MainContext.Provider>;
};

export const useTheme = () => {
  return useContext(MainContext);
};
